function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  fill: "#fff",
  r: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.5 0c-4.77272727 0-8.84863636 2.90266667-10.5 7 1.65136364 4.0973333 5.72727273 7 10.5 7 4.7727273 0 8.8486364-2.9026667 10.5-7-1.6513636-4.09733333-5.7272727-7-10.5-7zm0 11.6666667c-2.63454545 0-4.77272727-2.0906667-4.77272727-4.6666667s2.13818182-4.66666667 4.77272727-4.66666667c2.6345455 0 4.7727273 2.09066667 4.7727273 4.66666667s-2.1381818 4.6666667-4.7727273 4.6666667zm0-7.4666667c-1.58454545 0-2.86363636 1.25066667-2.86363636 2.8s1.27909091 2.8 2.86363636 2.8c1.5845455 0 2.8636364-1.25066667 2.8636364-2.8s-1.2790909-2.8-2.8636364-2.8z",
  fill: "#666",
  fillRule: "nonzero",
  transform: "translate(14 17)"
}));

var SvgImgView = function SvgImgView(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img_view.f9a16109.svg";
export { ForwardRef as ReactComponent };